import { onMount } from 'svelte';
import { writable } from 'svelte/store';
export function useAsync(fn, { defaultValue = null, defaultArgs = [], skip = false, } = {}) {
    let res = writable({
        loading: false,
        data: defaultValue,
        error: null,
        callTimes: 0,
    });
    const call = async (...args) => {
        try {
            res.update(pre => {
                return Object.assign(Object.assign({}, pre), { loading: true });
            });
            const data = await fn(...(args.length > 0 ? args : defaultArgs));
            res.update(pre => {
                return Object.assign(Object.assign({}, pre), { loading: false, data: data !== null && data !== void 0 ? data : defaultValue, error: null, callTimes: pre.callTimes + 1 });
            });
            return data;
        }
        catch (error) {
            res.update(pre => {
                return Object.assign(Object.assign({}, pre), { loading: false, data: defaultValue, error, callTimes: pre.callTimes + 1 });
            });
            throw error;
        }
    };
    onMount(() => {
        !skip && call();
    });
    return [res, call];
}
